// extracted by mini-css-extract-plugin
export default {"layout_main_div":"Layout_layout_main_div__z6EkG","layout_main_column":"Layout_layout_main_column__0XugO"};